import { LinearProgress } from '@mui/material';
import React from 'react';
import { Modal } from '../../../components';
import { useSelector } from '../../../stores';

export const RoutesExportModal: React.FC = () => {
  const { routesExportPercentage, routesExportModalIsOpen } = useSelector(
    (state) => state.routesListReducer,
  );

  return (
    <Modal
      open={routesExportModalIsOpen}
      onClose={() => {}}
      title='Preparando exportação'
      noCloseButton
    >
      <LinearProgress
        variant='determinate'
        value={routesExportPercentage}
        sx={{ height: '20px', borderRadius: '40px' }}
      />
    </Modal>
  );
};
